require('./_ajaxLoadHandler.class');

$(() => {
    const CHECKED_CLASS = 'check--checked';
    // const UNCHECKED_CLASS = 'check--unchecked';

    // $(document).on('click', '[data-ajax-smart-filter] input[type=radio]:not(:checked)', (event) => {
    $(document).on(
        'change',
        '[data-ajax-smart-filter] input[type=radio],' +
        '[data-ajax-smart-filter] input[type=checkbox]', (event) => {
            const $target = $(event.currentTarget);
            const $wrapper = $target.closest('.filter-options');

            setTimeout(function () {
                $wrapper.find('label').removeClass(CHECKED_CLASS);

                $wrapper.find('input:checked').each((i, item) => {
                    const $item = $(item);
                    $item.closest('label').addClass(CHECKED_CLASS);
                });
            });
        });

    $(document).on('click', `[data-ajax-smart-filter] label.${CHECKED_CLASS}`, (event) => {
        const $target = $(event.currentTarget);
        const $input = $target.find('input');

        $input.prop('checked', false).trigger('change');
    });

    $(document).on('reset', '[data-ajax-smart-filter]', function (event) {
        const $this = $(this);

        $this.find('fieldset').attr('disabled', '');

        __ajaxLoaderHandler.loadContent({
            url: $this.prop('action') || location.href,
            query: '',
            method: $this.prop('method') || 'post',
            selector: $this.data('ajax-smart-filter'),
            isJson: $this.data('json-content'),
            isParseSelector: $this.data('parse-selector'),
            isAppend: $this.data('append-content') || false,
            isKeepHistory: $this.data('keep-history') || false,
            isScrollOnLoad: $this.data('scroll-on-load') || false,
            onSuccess: () => {
                $this.find('fieldset').removeAttr('disabled');
            }
        });
    });

    $(document).on('submit', '[data-ajax-smart-filter]', function (event, eventData) {
        event.preventDefault();
        const $this = $(this);
        const activeTab = $this.find('.filter-group.active').data('id');
        let data;

        let dataQuery = (function prepareQuery() {

            // Обнуляем значения ползунка, если значения MIN и MAX равны
            // (то есть, значение сброшено)
            const $inputMin = $this.find('[data-smart-filter-range-min]');
            const $inputMax = $this.find('[data-smart-filter-range-max]');
            if ($inputMin.val() && $inputMin.val() === $inputMax.val()) {
                $inputMin.val('');
                $inputMax.val('');
            }

            data = $this.serializeArray();
            let dataQuery = $this.data('query') || {};

            $.each(data, function (i, item) {
                dataQuery[item.name] = item.value;
            });

            if (typeof eventData === 'object' && typeof eventData.query === 'object') {
                $.extend(dataQuery, eventData.query);
            }

            $this.find('fieldset').attr('disabled', '');

            return dataQuery;
        })();

        // Собираем данные о скролле списков,
        // потом будем крутить к этому месту
        window.smartFilterScroll = {};
        $('.scrollable').each((i, item) => {
            const $item = $(item);
            const $viewPort = $item.find('.os-viewport');

            window.smartFilterScroll[$item.data('filter')] = $viewPort.scrollTop();
        });

        __ajaxLoaderHandler.loadContent({
            url: $this.data('action') || $this.prop('action'),
            query: dataQuery,
            method: $this.prop('method') || 'post',
            selector: $this.data('ajax-smart-filter'),
            isJson: $this.data('json-content'),
            isParseSelector: $this.data('parse-selector'),
            isAppend: $this.data('append-content') || false,
            isKeepHistory: $this.data('keep-history') || false,
            isScrollOnLoad: $this.data('scroll-on-load') || false,
            onSuccess: () => {
                $this.find('fieldset').removeAttr('disabled');

                $this.find(`.filter-group[data-id="${activeTab}"]`).addClass('active');

                $(window).trigger('resize');

                $.each(window.smartFilterScroll, (key, value) => {
                    $(`.scrollable[data-filter="${key}"] .os-viewport`).scrollTop(parseFloat(value - 0));
                });
            }
        });
    });

});